export default class Search {
	constructor($module) {
		this.$module = $module;
		this.$input = this.$module.querySelector(".bc-input");
		this.$clear = this.$module.querySelector("[data-clean-search]");
		this.$form = this.$module.querySelector(".bc-search__form");

		if (!this.$input || !this.$clear) {
			return;
		}

		if (!this.$input.getAttribute("enterkeyhint")) {
			this.$input.setAttribute("enterkeyhint", "search");
		}

		this.toggleClearVisibility();

		this.$input.addEventListener("input", () => {
			this.toggleClearVisibility();
		});

		this.$input.addEventListener("keydown", (event) => {
			if (event.key !== "Enter") {
				return;
			}

			if (!this.$form) {
				return;
			}

			event.preventDefault();
			if (typeof this.$form.requestSubmit === "function") {
				this.$form.requestSubmit();
				return;
			}
			this.$form.submit();
		});

		this.$clear.addEventListener("click", () => {
			this.$input.value = "";
			this.toggleClearVisibility();
			this.$input.focus();
		});
	}

	toggleClearVisibility() {
		const hasValue = this.$input.value.trim().length > 0;
		this.$clear.classList.toggle("is-visible", hasValue);
	}
}
